import * as React from "react"
import { Box } from "@mui/material"
import { SelectSeeker } from "@ui-seeker/core"

import { GROUPED_BY } from "@constants"
import { groupedBy } from "@signals"

const OPTIONS = [
	{ label: 'Market', value: GROUPED_BY.COUNTRY },
	{ label: 'Retailer', value: GROUPED_BY.RETAILER }
]


export default function SkuDetailsPricingTableActions({ handleChangeGroupBy }) {

    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
		 <SelectSeeker
            options={OPTIONS}
            label="Group By"
            sx={{ width: 150}}
            value={groupedBy.value}
            onChange={handleChangeGroupBy}
	    />
	</Box>
}